import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Message, SelectItem } from 'primeng/api';
import { Permissao } from 'src/app/admihair/api/dto/permissao';
import { TributacaoEmpresa } from 'src/app/admihair/api/dto/tributacao-empresa';
import { TributacaoRecolhimento } from 'src/app/admihair/api/dto/tributacao-recolhimento';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { TributacaoEmpresaService } from 'src/app/admihair/service/tributacao-empresa.service';
import { TributacaoRecolhimentoService } from 'src/app/admihair/service/tributacao-recolhimento.service';

@Component({
  selector: 'app-tributacao-editar',
  templateUrl: './tributacao-editar.component.html',
  styleUrls: ['./tributacao-editar.component.scss']
})
export class TributacaoEditarComponent implements OnInit {

  @Output() emissor = new EventEmitter();

  constructor(
    private tributacaoService: TributacaoEmpresaService,
    private tributacaoRecolhimentoService: TributacaoRecolhimentoService,
    private erroService: ErroService) { }

  @ViewChild('f') form?: NgForm;

  @Input() id?: number;
  messages: Message[] = [{ severity: '', summary: '', detail: '' }];
  messagemVisivel: boolean = false;
  progressoRequisicao: boolean = false;
  
  tributacao?: TributacaoEmpresa;
  opcoesCertificadoDigital: SelectItem[] = [{label: 'SIM', value: 'S',}, {label: 'NÃO', value: 'N'}];
  crts: SelectItem[] = [
    {label: 'SIMPLES NACIONAL', value: 'SIMPLES_NACIONAL'},
    {label: 'SN - EXCESSO SUBLIMITE', value: 'SN_EXCESSO_SUBLIMITE'},
    {label: 'REGIME NORMAL', value: 'REGIME_NORMAL'}
  ];
  tipoRegistros: String[] = ['DANFE', 'RPS'];
  tiposTributacaoR: TributacaoRecolhimento[] = [];
  tiposTributacaoT: TributacaoRecolhimento[] = [];

  ngOnInit(): void {
    this.carregarTiposTributacao();
  }

  atualizar(){
    this.progressoRequisicao = true;
    this.tributacaoService.atualizar(this.tributacao, this.id).subscribe({
      next: (data: TributacaoEmpresa) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.rolarTela();
      },
      error: (err: any) => {
        console.log('erro', err)
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })
    
  }

  carregarTiposTributacao(){
    this.tributacaoRecolhimentoService.listarTodos().subscribe({
      next: (data: TributacaoRecolhimento[]) => {
        this.tiposTributacaoR = data.filter(t => t.opcao === 'R');
        this.tiposTributacaoT = data.filter(t => t.opcao === 'T');
        this.carregarTributacao();
      },
      error: (err: any) => {
        console.log(err);
      }
    })
  }

  carregarTributacao(){
    this.tributacaoService.buscarPorId(this.id).subscribe({
      next: (data: TributacaoEmpresa) => {
        this.tributacao = data;
        console.log(data)
      },
      error: (err: any) => {

      }
    })

  }

  

  voltar(){
    this.emissor.emit({modo: 'LISTAR'});
  }


  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
  

}
